import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Notice = ({ className }) => (
  <div className={className}>
    <span>Notice</span>
    <p>
      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Et doloremque
      nemo blanditiis commodi numquam accusantium reiciendis quo quasi vitae
      veniam possimus, praesentium saepe, in quidem aliquid, dolor magni unde
      architecto?
    </p>
  </div>
);

Notice.propTypes = {
  className: PropTypes.string.isRequired,
};

export default styled(Notice)`
  span {
    color: hsl(0, 79%, 72%);
    font-weight: bold;
    font-size: 1rem;
    text-transform: uppercase;
  }
`;
